import { defaultHeaders } from 'utils/network/ServiceHelper';
import { api } from 'utils/network/api';
import { axios } from 'utils/network/axios';

const url = process.env.REACT_APP_BASE_URL;

class RoleAccessService {
  list(body) {
    return api({
      baseUrl: url,
      endpoint: '/role-access/list',
      method: 'POST',
      body: JSON.stringify(body),
      headers: defaultHeaders
    });
  }

  post(body) {
    return axios.post('/role-access', body);
  }

  put(body) {
    return axios.put(`/role-access/${body.id}`, body);
  }

  delete(id) {
    return axios.delete(`/role-access/${id}`);
  }
}

export default new RoleAccessService();
